module.exports = __webpack_public_path__ + "img/cookies_ban.png";